module.exports = __webpack_public_path__ + "static/img/altcoin.0507661.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/altcoin.png
// module id = +nH2
// module chunks = 16